//allows you to dynamically shift bootstrap column classes of direct child elements based on a maximum number of items allowed per row and an optionally provided breakpoint
//uses the "col-{breakpoint}" classes to support the dynamicism
$('[data-bs-maxcols]').each(function () {

    var maxColumns = parseInt($(this).attr('data-bs-maxcols')) || 4;
    var breakpoint = $(this).attr('data-bs-breakpoint') ?? 'lg';
    var colClassNumber = 12 / maxColumns;

    function columnObserverCallback(mutations) {
        for (let mutation of mutations) {
            if (mutation.type === 'childList') {
                console.debug('Bootstrap Column Mutation detected');

                var targetChildren = $(mutation.target).children('[class*=col-]');

                if (targetChildren && targetChildren.length > maxColumns) {
                    console.debug("Updating Bootstrap Columns");

                    for (var i = 0; i < targetChildren.length; i += maxColumns) {
                        //break into groups
                        var columnGroup = targetChildren.slice(i, i + maxColumns);

                        $(columnGroup).each(function () {
                            //if the row doesn't fill to the max, use col-{breakpoint}
                            if (columnGroup.length < maxColumns) {
                                $(this).addClass('col-' + breakpoint);
                                $(this).removeClass('col-' + breakpoint + '-' + colClassNumber);
                            }
                            //otherwise, use col-{breakpoint}-{colClassNumber}
                            else {
                                $(this).removeClass('col-' + breakpoint);
                                $(this).addClass('col-' + breakpoint + '-' + colClassNumber);
                            }
                        });
                    }

                }
            }
            else {
                $(targetChildren).each(function (index) {
                    $(this).addClass('col-' + breakpoint);
                    $(this).removeClass('col-' + breakpoint + '-' + colClassNumber);
                });
            }
        }
    }

    var element = $(this)[0];
    var options = {
        childList: true
    };
    var observer = new MutationObserver(columnObserverCallback);

    observer.observe(element, options);
});

$('[data-toggle="tab"]').on('show.bs.tab', function (event) {
    //event.target // newly activated tab
    //event.relatedTarget // previous active tab
    //event.preventDefault();
    //location.hash = $(event.target).attr('id');
})

function activateHashBSElement() {
    if (location.hash !== null && location.hash !== "") {

        var targetElement = $(location.hash);

        if (targetElement.length) {
            if (targetElement.attr("data-toggle") === "tab") {
                targetElement.tab('show');
            }

            //expand bs hidden section on load
            //collapsibles
            if (targetElement.hasClass("collapse")) {

                if (targetElement.hasClass("show")) {
                    //if a target is already shown, scroll to it (since showing it does nothing)
                    scrollIntoAdjustedView(targetElement.closest('[data-scroll-margin-top]'));
                }
                else {
                    targetElement.collapse("show");
                }
            }

            //pills (target the activatable link, not the hidden element itself)
            if (targetElement.hasClass("tab-pane")) {

                if (targetElement.hasClass('active')) {
                    //if a target is already active, scroll to it (since showing it does nothing)
                    scrollIntoAdjustedView(targetElement.closest('[data-scroll-margin-top]'));
                }
                else {
                    $('a[href="' + location.hash + '"]').tab('show');
                }
            }
        }
    }
}

//extension of popovers functionality
$('[data-toggle="popover"]').popover({
    html: true,
    content: function () {

        if ($(this).attr('data-content-source')) {
            return $($(this).attr('data-content-source')).html();
        }
    }
}).on('shown.bs.popover', function (e) {
    var popover = jQuery(this);
    jQuery(this).parent().find('[data-close]').on('click', function (e) {
        popover.popover('hide');
    });
});

//trick that uses hidden elements in the dom to determine the current bootstrap column size in javascript
window.currentBSSize = function currentBSSize() {
    return $('#js-bs-size-detector').find('div:visible').data('size');
}

$('.collapse').not('[data-no-change-hash]').on('show.bs.collapse', function (e) { 
    changeUrlHash($(e.target).attr('id'));
});

$('[data-toggle="pill"]').on('show.bs.tab', function (e) {
    changeUrlHash($(e.target).attr('href'));
});

window.scrollIntoAdjustedView = function (target) {
    // Does a scroll target exist?
    if (target.length) {

        //pre calculated offset
        var headerOffset = parseInt(target.css("scroll-margin-top"), 10);

        if (!target.hasInlineStyle('scroll-margin-top')) {
            console.debug("flagged");
        }

        var targetOffset = target.offset().top;
        var calculatedOffset = targetOffset - headerOffset;

        //compensating for unknown pixel offset
        calculatedOffset = calculatedOffset + 1;

        $('html, body').animate({
            scrollTop: calculatedOffset
        }, 250, function () {
            // Callback after animation 
            // Must change focus!
            var $target = $(target);
            $target.focus();
            if ($target.is(":focus")) { // Checking if the target was focused
                return false;
            } else {
                $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
                $target.focus(); // Set focus again
            };
        });
    }
}

//this must trigger on shown to compensate for other elements being collapsed
$('[bs-scroll-on-show]').on('shown.bs.collapse', function (e) {
    scrollIntoAdjustedView($(e.target).closest('[data-scroll-margin-top]'));
});

$('[bs-scroll-on-show]').on('show.bs.collapse, show.bs.tab', function (e) {
    scrollIntoAdjustedView($($(e.target).attr('href')).closest('[data-scroll-margin-top]'));
});

//image load dependent functions
$(window).on('load', function () {
    activateHashBSElement();
});

$(document).ready(function () {

});